<template>
  <div style="background: #f8f8f8;padding: 20px;" v-loading='loading'>
    <div class="container">
      <div class="title">我的志愿表
        <!-- <span>剩余填报次数：{{}}</span> -->
      </div>
      <el-table :data="records" style="width: 100%" border stripe>
        <el-table-column prop="name" align="center" label="考生名称"></el-table-column>
        <el-table-column prop="year" align="center" label="报考年份"></el-table-column>
        <el-table-column prop="score" align="center" label="高考成绩"></el-table-column>
        <el-table-column align="center" label="选科组合">
          <template slot-scope="scope">
            {{scope.row.first}} , {{scope.row.second0}} , {{scope.row.second1}}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" align="center" label="创建时间"></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <span class="btn" @click="toDetail(scope)">查看</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="pageBox" v-if="records.length != 0">
        <el-pagination style="margin-top:10px;" @current-change="currentChange" @size-change="sizeChange" background
          :total="total" :current-page.sync="page.currentPage" :page-sizes="page.pageSizes" :page-size="page.pageSize"
          layout="total,sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        loading: false,
        page: {
          pageSize: 10,
          currentPage: 1,
          pageSizes: [10, 30, 50]
        },

        records: [],
        total: 0,
        user: {
          id: ''
        }
      }
    },
    mounted() {
      console.log(this.$parent.user)
      this.loadData()
    },
    methods: {
      loadData() {
        this.loading = true
        this.$api.post('aspiration/page', {
          pageNumber: this.page.currentPage,
          pageSize: this.page.pageSize,
          userId: this.user.id
        }, res => {
          this.records = res.records || []
          this.total = res.total
          this.loading = false
        })
      },
      currentChange(val) {
        this.page.currentPage = val
        this.loadData()
      },
      sizeChange(val) {
        this.page.pageSize = val
        this.page.currentPage = 1
        this.loadData()
      },
      toDetail(item) {
        this.$router.push({
          path: '/zyb',
          query: {
            id: item.row.id
          }
        })
      }
    }
  }
</script>

<style>
  .container {
    width: 1230px;
    margin: 0 auto;
    background: #f8f8f8;
    padding: 20px 30px;
    min-height: 500px;

  }

  .container .title {
    font-size: 24px;
    color: #333;
    padding-bottom: 10px;
    border-bottom: 1px solid #ddd;
    margin-bottom: 30px;
    font-weight: 500;
  }

  .btn {
    cursor: pointer;
    color: blue;
  }
</style>



// WEBPACK FOOTER //
// src/components/my.vue